(function () {
    class NullAuthenticationStrategy {
        constructor(config) {}
        login(options) {
            return Promise.resolve();
        }
        logout() {
            return Promise.resolve();
        }
        isAuthenticated() {
            return true;
        }
        isAuthorized () {
            return true;
        }
        user() {
            return { email: null };
        }
    }
    AuthenticationProvider.add("NullAuthenticationStrategy", (config) => {
        return new NullAuthenticationStrategy(config);
    });
})();
